export default __webpack_public_path__ + "static/media/awaiting6.b7351ff8.svg";